class GatewayPdfExport {
    constructor(ajaxData, dismissModal = null, submitButton = null) {
        const thisClass = this;
        /** If there is no modal - show loading modal */
        if(!dismissModal && !submitButton){
            bootstrap.Modal.getOrCreateInstance(document.getElementById('loading-modal')).show();
        }

        /** Get access logs data */
        $.ajax({
            url: '/gateway-access-logs/?do=getGatewayPdf',
            type: 'GET',
            dataType: '',
            data: ajaxData,
            success: function (data) {
                if(data['data'].length > 0) {
                    thisClass.createPdf(data);
                } else {
                    toastr.error('No data for the selected period.')
                }
                thisClass.hideModal(dismissModal, submitButton);
            },
            error: function (request, status, error) {
                thisClass.hideModal(dismissModal, submitButton);
                toastr.error('Unexpected error occurred. Please try it again later or contact our support team.')
            }
        });
    }
    hideModal(dismissModal, submitButton) {
        if(!dismissModal && !submitButton){
            setTimeout(function(){
                bootstrap.Modal.getOrCreateInstance(document.getElementById('loading-modal')).hide();
            }, 200);
        } else {
            new DismissModal(dismissModal).enable();
            bootstrap.Modal.getOrCreateInstance(document.getElementById(dismissModal)).hide();
            submitButton.setAttribute('data-kt-indicator', 'off');
            submitButton.disabled = false;
        }
    }
    createPdf(data){
        const totalPagesExp = "{total_pages_count_string}";
        const head = [['MEMBER', 'GATEWAY', 'FROM IP', 'PROTOCOL', 'START', 'STOP', 'DURATION', 'DATA']];
        const rows = [];
        const arrowUpSrc = '/media/goodaccess/pdf-export-images/arrow-up.png';
        const arrowDownSrc = '/media/goodaccess/pdf-export-images/arrow-down.png';
        const goodAccessLogoSrc = '/media/goodaccess/pdf-export-images/goodaccess-logo.png';

        for (let i in data['data']) {
            let avatarSrc = '/media/goodaccess/pdf-export-images/device.png';
            if (data['data'][i]['avatarID'] || data['data'][i]['isIdp']) {
                avatarSrc = '/media/goodaccess/avatars/PNG/256x256/Icon with face-' + data['data'][i]['avatarID'] + '.png';
            }
            let gatewaySrc = '/media/goodaccess/country-flags/png100px/' + data['data'][i]['gatewayIso2'] + '.png';

            rows.push([
                {
                    content: data['data'][i].name + '\n' + data['data'][i].username,
                    avatarSrc: avatarSrc,
                    name: data['data'][i].name
                },
                {
                    content: data['data'][i].gatewayName + '\n' + data['data'][i].gatewayIP,
                    gatewaySrc: gatewaySrc
                },
                data['data'][i].from_ip,
                data['data'][i].log_protocol,
                data['data'][i].start.replace(' <br> ', '\n'),
                data['data'][i].stop.replace(' <br> ', '\n'),
                data['data'][i].duration,
                {
                    content: data['data'][i].uploadedData + '\n' + data['data'][i].downloadedData,
                    arrowUpSrc: arrowUpSrc,
                    arrowDownSrc: arrowDownSrc
                },
            ]);
        }

        const pdf = new jsPDF('l', 'pt', 'a4');
        pdf.setProperties({
            title: 'GoodAccess - Gateway Access Logs',
            subject: 'Gateway Access Logs - Team '+data.organizationName,
            author: 'GoodAccess s.r.o.',
            creator: 'GoodAccess s.r.o.'
        });
        let table = new autoTable(pdf, {
            head: head,
            body: rows,
            theme: 'plain',
            margin: {
                top: 50
            },
            styles: {
                overflow: 'linebreak',
                fontSize: 9,
                textColor: [14, 43, 143],
                font: 'helvetica',
                fontStyle: 'normal',
                valign: 'middle'
            },
            columnStyles: {
                0: {
                    cellPadding: {
                        left: 30
                    }
                },
                1: {
                    cellPadding: {
                        left: 30
                    }
                },
                7: {
                    cellPadding: {
                        left: 15
                    }
                },
            },
            headStyles: {
                fillColor: [243, 245, 249],
                textColor: [14, 43, 143],
                font: 'helvetica',
                fontStyle: 'bold',
                fontSize: 10
            },
            didDrawPage: () => {
                /** Set font for header and footer */
                pdf.setFontSize(8);
                pdf.setFont("helvetica", "italic", "400");
                pdf.setTextColor(14, 43, 143);

                /** Logo */
                pdf.addImage(goodAccessLogoSrc, 45, 20, 120, 24);

                /** Export from/to date */
                let startDate = 'From: ' + data.start;
                let xOffsetStart = (pdf.internal.pageSize.width) - (pdf.getStringUnitWidth(startDate) * pdf.internal.getFontSize() + 45);
                pdf.text(startDate, xOffsetStart, 30);
                let endDate = 'To: ' + data.end;
                let xOffsetEnd = (pdf.internal.pageSize.width) - (pdf.getStringUnitWidth(endDate) * pdf.internal.getFontSize() + 45);
                pdf.text(endDate, xOffsetEnd, 40);

                /** Paging */
                let pagingStr = "Page " + pdf.internal.getNumberOfPages();
                if (typeof pdf.putTotalPages === 'function') {
                    pagingStr = pagingStr + " of " + totalPagesExp;
                }
                let xOffsetPage = (pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth('Page xx of xx') * pdf.internal.getFontSize() / 2);
                pdf.text(pagingStr, xOffsetPage, pdf.internal.pageSize.height - 15);

                /** Organization name */
                let organizationName = 'Team Name: ' + data.organizationName;
                pdf.text(organizationName, 45, pdf.internal.pageSize.height - 15);

                /** Today Date */
                let todayDate = data.todayDate;
                let xOffsetDate = (pdf.internal.pageSize.width) - (pdf.getStringUnitWidth(todayDate) * pdf.internal.getFontSize() + 45);
                pdf.text(todayDate, xOffsetDate, pdf.internal.pageSize.height - 15);
            },
            willDrawCell: (data) => {
                if (data.cell.section === 'body') {
                    if (data.cell.raw.avatarSrc) {
                        /** Add avatar image */
                        pdf.addImage(data.cell.raw.avatarSrc, data.cell.x + 5, data.cell.y + 5, data.cell.height - 10, data.cell.height - 10);
                    }
                    if (data.cell.raw.gatewaySrc) {
                        /** Add Gateway flag */
                        pdf.addImage(data.cell.raw.gatewaySrc, data.cell.x + 5, data.cell.y + 7, 20, data.cell.height - 14);
                    }
                    if (data.cell.raw.arrowUpSrc) {
                        /** Add arrow up image (upload) */
                        pdf.addImage(data.cell.raw.arrowUpSrc, data.cell.x + 5, data.cell.y + 5, 7, 9);
                    }
                    if (data.cell.raw.arrowDownSrc) {
                        /** Add arrow down image (download) */
                        pdf.addImage(data.cell.raw.arrowDownSrc, data.cell.x + 5, data.cell.y + 16, 7, 9);
                    }
                }
            },
            tableWidth: 'auto',
            rowPageBreak: 'avoid',
            startY: 50,
            startX: 0
        });
        if (typeof pdf.putTotalPages === 'function') {
            pdf.putTotalPages(totalPagesExp);
        }
        pdf.save('Gateway Access Logs.pdf');
        window.open(pdf.output('bloburl'), '_blank');
    }
}
window.GatewayPdfExport = GatewayPdfExport;